export class ArbetsorderProduktvalSummaryTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        summa: "Summa",
        timmerandel: "Timmerandel",
        grot: "Grot (schablon)"
    };
}
